import {
    IPublicationSearchIndexContentNodeDataStore,
    IPublicationSearchIndexDataStore,
    IPublicationSearchIndexDocumentDataStore,
    IVanillaReaderStoreContentPositionData,
    IVanillaReaderStoreDocumentLandmarkData,
    IVanillaReaderStoreLandmarkData,
    IVanillaReaderStoreNavigationCollection,
    IVanillaReaderStoreNavigationItem,
    IVanillaReaderStoreNavigationTreeData,
    IVanillaReaderStorePublicationCacheData,
    IVanillaReaderStorePublicationData,
    IVanillaReaderStorePublicationLandmarkData,
    IVanillaReaderStorePublicationOptionsData,
} from "./VanillaReaderStoreModel";
import {
    IVanillaReaderContentPositionData,
    IVanillaReaderDocumentLandmarkData,
    IVanillaReaderLandmarkData,
    IVanillaReaderNavigationCollection,
    IVanillaReaderNavigationItem,
    IVanillaReaderNavigationTreeData,
    IVanillaReaderPublicationCacheData,
    IVanillaReaderPublicationData,
    IVanillaReaderPublicationLandmarkData,
    IVanillaReaderPublicationOptionsData, IVanillaReaderFontFace, IVanillaReaderFontSet,
    IVanillaReaderPublicationStyleOptions
} from "../VanillaReader/VanillaReaderModel";
import {
    IPublicationSearchIndexContentNodeData,
    IPublicationSearchIndexData,
    IPublicationSearchIndexDocumentData
} from "../utils/PublicationSearchIndexDataFactory";
import {VanillaReaderOptionsIndexedDbDataStoreConversions} from "./VanillaReaderOptionsIndexedDbDataStoreConversions";
import {
    IPublicationStyleFontFace,
    IPublicationStyleFontSet,
    IPublicationStyleOptions
} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";

export class VanillaReaderPublicationIndexedDbDataStoreConversions {
    static toApplicationPublicationCacheData(storeData: IVanillaReaderStorePublicationCacheData): IVanillaReaderPublicationCacheData {
        return {
            _id: storeData._id,
            publicationId: storeData.publicationId,
            landmarkData: storeData.landmarkData,
            storageState: storeData.storageState,
            searchIndexData: storeData.searchIndexData,
            navigationTreeData: storeData.navigationTreeData,
            timelineData: storeData.timelineData
        }
    }

    static maybeToApplicationPublicationCacheData(storeData: IVanillaReaderStorePublicationCacheData | undefined): IVanillaReaderPublicationCacheData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationPublicationCacheData(storeData) : undefined;
    }

    static toStorePublicationCacheData(appData: IVanillaReaderPublicationCacheData): IVanillaReaderStorePublicationCacheData {
        return {
            _id: appData._id,
            publicationId: appData.publicationId,
            landmarkData: appData.landmarkData,
            storageState: appData.storageState,
            searchIndexData: appData.searchIndexData,
            navigationTreeData: appData.navigationTreeData,
            timelineData: appData.timelineData
        }
    }

    static toApplicationPublicationLandmarkData(storeData: IVanillaReaderStorePublicationLandmarkData): IVanillaReaderPublicationLandmarkData {
        return {
            _id: storeData._id,
            publicationId: storeData.publicationId,
            documents: storeData.documents
        }
    }

    static maybeToApplicationPublicationLandmarkData(storeData: IVanillaReaderStorePublicationLandmarkData | undefined): IVanillaReaderPublicationLandmarkData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationPublicationLandmarkData(storeData) : undefined;
    }

    static toStorePublicationLandmarkData(appData: IVanillaReaderPublicationLandmarkData): IVanillaReaderStorePublicationLandmarkData {
        return {
            _id: appData._id,
            publicationId: appData.publicationId,
            documents: appData.documents
        }
    }

    static toApplicationDocumentLandmarkData(storeData: IVanillaReaderStoreDocumentLandmarkData): IVanillaReaderDocumentLandmarkData {
        return {
            documentIndex: storeData.documentIndex,
            headings: storeData.headings,
            tables: storeData.tables,
            figures: storeData.figures,
            audio: storeData.audio,
            video: storeData.video,
            lists: storeData.lists,
            sections: storeData.sections,
            articles: storeData.articles,
            asides: storeData.asides,
            footnotes: storeData.footnotes
        }
    }

    static maybeToApplicationDocumentLandmarkData(storeData: IVanillaReaderStoreDocumentLandmarkData | undefined): IVanillaReaderDocumentLandmarkData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationDocumentLandmarkData(storeData) : undefined;
    }

    static toStoreDocumentLandmarkData(appData: IVanillaReaderDocumentLandmarkData): IVanillaReaderStoreDocumentLandmarkData {
        return {
            documentIndex: appData.documentIndex,
            headings: appData.headings,
            tables: appData.tables,
            figures: appData.figures,
            audio: appData.audio,
            video: appData.video,
            lists: appData.lists,
            sections: appData.sections,
            articles: appData.articles,
            asides: appData.asides,
            footnotes: appData.footnotes
        }
    }

    static toApplicationLandmarkData(storeData: IVanillaReaderStoreLandmarkData): IVanillaReaderLandmarkData {
        return {
            parentId: storeData.parentId,
            timelinePosition: storeData.timelinePosition,
            subType: storeData.subType,
            description: storeData.description,
            locatorUrl: storeData.locatorUrl,
            attributes: storeData.attributes,
            blockClass: storeData.blockClass,
            blockType: storeData.blockType,
            children: storeData.children,
            id: storeData.id,
            locator: storeData.locator,
            marks: storeData.marks,
            resourceHrefs: storeData.resourceHrefs,
            textContent: storeData.textContent
        }
    }

    static maybeToApplicationLandmarkData(storeData: IVanillaReaderStoreLandmarkData | undefined): IVanillaReaderLandmarkData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationLandmarkData(storeData) : undefined;
    }

    static toStoreLandmarkData(appData: IVanillaReaderLandmarkData): IVanillaReaderStoreLandmarkData {
        return {
            parentId: appData.parentId,
            timelinePosition: appData.timelinePosition,
            subType: appData.subType,
            description: appData.description,
            locatorUrl: appData.locatorUrl,
            attributes: appData.attributes,
            blockClass: appData.blockClass,
            blockType: appData.blockType,
            children: appData.children,
            id: appData.id,
            locator: appData.locator,
            marks: appData.marks,
            resourceHrefs: appData.resourceHrefs,
            textContent: appData.textContent
        }
    }

    static toApplicationIPublicationSearchIndexData(storeData: IPublicationSearchIndexDataStore): IPublicationSearchIndexData {
        return {
            hashSignature: storeData.hashSignature,
            metadata: storeData.metadata,
            documents: storeData.documents,
            publicationIndexedTextLength: storeData.publicationIndexedTextLength
        }
    }

    static maybeToApplicationIPublicationSearchIndexData(storeData: IPublicationSearchIndexDataStore | undefined): IPublicationSearchIndexData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationIPublicationSearchIndexData(storeData) : undefined;
    }

    static toStoreIPublicationSearchIndexData(appData: IPublicationSearchIndexData): IPublicationSearchIndexDataStore {
        return {
            hashSignature: appData.hashSignature,
            metadata: appData.metadata,
            documents: appData.documents,
            publicationIndexedTextLength: appData.publicationIndexedTextLength
        }
    }

    static toApplicationIPublicationSearchIndexDocumentData(storeData: IPublicationSearchIndexDocumentDataStore): IPublicationSearchIndexDocumentData {
        return {
            tocTitle: storeData.tocTitle,
            locator: storeData.locator,
            contentNodes: storeData.contentNodes,
            indexedText: storeData.indexedText,
            charOffsetInPublicationIndexedText: storeData.charOffsetInPublicationIndexedText,
            indexInPublicationSpine: storeData.indexInPublicationSpine
        }
    }

    static maybeToApplicationIPublicationSearchIndexDocumentData(storeData: IPublicationSearchIndexDocumentDataStore | undefined): IPublicationSearchIndexDocumentData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationIPublicationSearchIndexDocumentData(storeData) : undefined;
    }

    static toStoreIPublicationSearchIndexDocumentData(appData: IPublicationSearchIndexDocumentData): IPublicationSearchIndexDocumentDataStore {
        return {
            tocTitle: appData.tocTitle,
            locator: appData.locator,
            contentNodes: appData.contentNodes,
            indexedText: appData.indexedText,
            charOffsetInPublicationIndexedText: appData.charOffsetInPublicationIndexedText,
            indexInPublicationSpine: appData.indexInPublicationSpine
        }
    }

    static toApplicationIPublicationSearchIndexContentNodeData(storeData: IPublicationSearchIndexContentNodeDataStore): IPublicationSearchIndexContentNodeData {
        return {
            tocTitle: storeData.tocTitle,
            id: storeData.id,
            locator: storeData.locator,
            charRangeInIndexedDocumentText: storeData.charRangeInIndexedDocumentText,
            type: storeData.type,
            attributes: storeData.attributes,
            documentIndex: storeData.documentIndex
        }
    }

    static maybeToApplicationIPublicationSearchIndexContentNodeData(storeData: IPublicationSearchIndexContentNodeDataStore | undefined): IPublicationSearchIndexContentNodeData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationIPublicationSearchIndexContentNodeData(storeData) : undefined;
    }

    static toStoreIPublicationSearchIndexContentNodeData(appData: IPublicationSearchIndexContentNodeData): IPublicationSearchIndexContentNodeDataStore {
        return {
            tocTitle: appData.tocTitle,
            id: appData.id,
            locator: appData.locator,
            charRangeInIndexedDocumentText: appData.charRangeInIndexedDocumentText,
            type: appData.type,
            attributes: appData.attributes,
            documentIndex: appData.documentIndex
        }
    }

    static toApplicationNavigationTreeData(storeData: IVanillaReaderStoreNavigationTreeData): IVanillaReaderNavigationTreeData {
        return {
            collections: storeData.collections,
            items: storeData.items
        }
    }

    static maybeToApplicationNavigationTreeData(storeData: IVanillaReaderStoreNavigationTreeData | undefined): IVanillaReaderNavigationTreeData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationNavigationTreeData(storeData) : undefined;
    }

    static toStoreNavigationTreeData(appData: IVanillaReaderNavigationTreeData): IVanillaReaderStoreNavigationTreeData {
        return {
            collections: appData.collections,
            items: appData.items
        }
    }

    static toApplicationNavigationCollection(storeData: IVanillaReaderStoreNavigationCollection): IVanillaReaderNavigationCollection {
        return {
            type: storeData.type,
            children: storeData.children
        }
    }

    static maybeToApplicationNavigationCollection(storeData: IVanillaReaderStoreNavigationCollection | undefined): IVanillaReaderNavigationCollection | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationNavigationCollection(storeData) : undefined;
    }

    static toStoreNavigationCollection(appData: IVanillaReaderNavigationCollection): IVanillaReaderStoreNavigationCollection {
        return {
            type: appData.type,
            children: appData.children
        }
    }

    static toApplicationNavigationItem(storeData: IVanillaReaderStoreNavigationItem): IVanillaReaderNavigationItem {
        return {
            title: storeData.title,
            collectionType: storeData.collectionType,
            locator: storeData.locator,
            timelineStartPosition: storeData.timelineStartPosition,
            children: storeData.children
        }
    }

    static maybeToApplicationNavigationItem(storeData: IVanillaReaderStoreNavigationItem | undefined): IVanillaReaderNavigationItem | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationNavigationItem(storeData) : undefined;
    }
    static maybeToStoreNavigationItem(appData: IVanillaReaderNavigationItem | undefined): IVanillaReaderStoreNavigationItem | undefined {
        return appData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toStoreNavigationItem(appData) : undefined;
    }
    static toStoreNavigationItem(appData: IVanillaReaderNavigationItem): IVanillaReaderStoreNavigationItem {
        return {
            title: appData.title,
            collectionType: appData.collectionType,
            locator: appData.locator,
            timelineStartPosition: appData.timelineStartPosition,
            children: appData.children
        }
    }

    static toApplicationPublicationOptionsData(storeData: IVanillaReaderStorePublicationOptionsData): IVanillaReaderPublicationOptionsData {
        return {
            _id: storeData._id,
            publicationId: storeData.publicationId,
            styleOptions: storeData.styleOptions ?
                VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationPublicationStyleOptions(storeData.styleOptions) :
                undefined,
            ttsOptions: VanillaReaderOptionsIndexedDbDataStoreConversions.maybeToApplicationTtsOptions(storeData.ttsOptions)
        }
    }

    static maybeToApplicationPublicationOptionsData(storeData: IVanillaReaderStorePublicationOptionsData | undefined): IVanillaReaderPublicationOptionsData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationPublicationOptionsData(storeData) : undefined;
    }

    static toStorePublicationOptionsData(appData: IVanillaReaderPublicationOptionsData): IVanillaReaderStorePublicationOptionsData {

        let optionsData: IVanillaReaderStorePublicationOptionsData = {
            _id: appData._id,
            publicationId: appData.publicationId,
        }

        if(appData.styleOptions) {
            optionsData.styleOptions = VanillaReaderPublicationIndexedDbDataStoreConversions.toStorePublicationStyleOptions(appData.styleOptions);
        }

        if(appData.ttsOptions) {
            optionsData.ttsOptions = VanillaReaderOptionsIndexedDbDataStoreConversions.maybeToStoreTtsOptions(appData.ttsOptions);
        }

        return optionsData;
    }

    static toApplicationPublicationData(storeData: IVanillaReaderStorePublicationData): IVanillaReaderPublicationData {
        return {
            id: storeData.id,
            fileName: storeData.fileName,
            fileSourceUri: storeData.fileSourceUri,
            format: storeData.format,
            url: storeData.url,
            title: storeData.title,
            isRtl: storeData.isRtl,
            isFixedLayout: storeData.isFixedLayout,
            isScripted: storeData.isScripted,
            isAudiobook: storeData.isAudiobook,
            hasMoSyncMedia: storeData.hasMoSyncMedia,
            metadata: storeData.metadata,
            coverImageAsBase64: storeData.coverImageAsBase64,
            language: storeData.language
        }
    }

    static maybeToApplicationPublicationData(storeData: IVanillaReaderStorePublicationData | undefined): IVanillaReaderPublicationData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationPublicationData(storeData) : undefined;
    }

    static toStorePublicationData(appData: IVanillaReaderPublicationData): IVanillaReaderStorePublicationData {
        return {
            id: appData.id,
            fileName: appData.fileName,
            fileSourceUri: appData.fileSourceUri,
            format: appData.format,
            url: appData.url,
            title: appData.title,
            isRtl: appData.isRtl,
            isFixedLayout: appData.isFixedLayout,
            isScripted: appData.isScripted,
            isAudiobook: appData.isAudiobook,
            hasMoSyncMedia: appData.hasMoSyncMedia,
            metadata: appData.metadata,
            coverImageAsBase64: appData.coverImageAsBase64,
            language: appData.language
        }
    }

    static toApplicationContentPositionData(storeData: IVanillaReaderStoreContentPositionData): IVanillaReaderContentPositionData {
        return {
            _id: storeData._id,
            publicationId: storeData.publicationId,
            contentBlockData: storeData.contentBlockData,
            contentRects: storeData.contentRects,
            locator: storeData.locator,
            navItemData: storeData.navItemData?.map(VanillaReaderPublicationIndexedDbDataStoreConversions.toStoreNavigationItem),
            documentIndex: storeData.documentIndex,
            timestamp: storeData.timestamp
        }
    }

    static maybeToApplicationContentPositionData(storeData: IVanillaReaderStoreContentPositionData | undefined): IVanillaReaderContentPositionData | undefined {
        return storeData ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationContentPositionData(storeData) : undefined;
    }

    static toStoreContentPositionData(appData: IVanillaReaderContentPositionData): IVanillaReaderStoreContentPositionData {
        return {
            _id: appData._id,
            publicationId: appData.publicationId,
            contentBlockData: appData.contentBlockData,
            contentRects: appData.contentRects,
            locator: appData.locator,
            navItemData: appData.navItemData?.map(VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationNavigationItem),
            documentIndex: appData.documentIndex,
            timestamp: appData.timestamp
        }
    }

    static toStorePublicationStyleOptions(appData: IVanillaReaderPublicationStyleOptions): IPublicationStyleOptions {
        return {
            fontSet: appData.fontSet ?
                VanillaReaderPublicationIndexedDbDataStoreConversions.toStorePublicationStyleFontSet(appData.fontSet):
                undefined,
            defaultFontFamily: appData.defaultFontFamily,
            palette: appData.palette,
            fontSizeScaleFactor: appData.fontSizeScaleFactor,
            pageMargins: appData.pageMargins,
            textAlignment: appData.textAlignment,
            lineHeightScaleFactor: appData.lineHeightScaleFactor
        }
    }

    static toApplicationPublicationStyleOptions(storeData: IPublicationStyleOptions): IVanillaReaderPublicationStyleOptions {
        return {
            defaultFontFamily: storeData.defaultFontFamily,
            palette: storeData.palette,
            fontSizeScaleFactor: storeData.fontSizeScaleFactor,
            pageMargins: storeData.pageMargins,
            textAlignment: storeData.textAlignment,
            lineHeightScaleFactor: storeData.lineHeightScaleFactor
        }
    }

    static toStorePublicationStyleFontSet(appFontSet: IVanillaReaderFontSet): IPublicationStyleFontSet {
        let fontFaces = appFontSet.fontFaces.map<IPublicationStyleFontFace>((fontFace: IVanillaReaderFontFace)=>{
            return {
                fontStyle: fontFace.fontStyle,
                fontStretch: fontFace.fontStretch,
                fontWeight: fontFace.fontWeight,
                family: fontFace.family,
                mediaType: fontFace.mediaType,
                src: '',
            };
        });

        return {
            fontFaces,
            defaults: appFontSet.defaults,
            selectors: appFontSet.selectors,
        }
    }
}
